import * as React from 'react';

const hubSpotIcon = (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="18" height="18" rx="4" fill="#017737"/>
    <path d="M13.9995 7.40117C13.9995 10.0152 12.3159 11.8031 9.90872 11.8031C8.76433 11.8031 7.82119 11.3307 7.46808 10.7403L7.48478 11.3474V15.0912H5.02744V5.41094C5.02744 5.27629 4.99403 5.24205 4.84215 5.24205H4V3.18487H6.05412C6.9965 3.18487 7.23267 3.99435 7.29949 4.34888C7.67007 3.72503 8.64587 3 10.0264 3C12.4002 2.99924 13.9995 4.7696 13.9995 7.40117ZM11.4913 7.41791C11.4913 6.01805 10.5823 5.05718 9.43714 5.05718C8.49475 5.05718 7.4339 5.68103 7.4339 7.43541C7.4339 8.58192 8.0733 9.7794 9.40373 9.7794C10.3803 9.77864 11.4913 9.07035 11.4913 7.41791Z" fill="white"/>
    </svg>
);

export default hubSpotIcon;
